module.exports = __webpack_public_path__ + "static/media/circle-x.e4e89599.svg";